import React from 'react';
import { CTABand } from '../../components/CTABand';
export function StartFreeFinalCTA() {
  return <CTABand headline="Ready to See the Difference?" copy="Give your child the gift of confidence and focus. Claim your free week today." data-id="element-3084" />;
}